<dx-popup
    #portalAnnouncementPopup
    title="News and Announcements"
    [minWidth]="isSmallScreen ? popupWidth : undefined"
    [minHeight]="isSmallScreen ? popupHeight : undefined"
    [maxWidth]="!isSmallScreen ? popupWidth : undefined"
    [maxHeight]="!isSmallScreen ? popupHeight : undefined"
    [showTitle]="true"
    [dragEnabled]="true"
    [deferRendering]="true"
    [showCloseButton]="true"
    [resizeEnabled]="true"
    [visible]="visible"
    (onHiding)="hide()"
    (onShown)="repaint($event)"
>
    <div
        *dxTemplate="let model of 'content'"
        id="portal-announcement-container"
        class="cc-portal-announcement-container"
    >
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="row">
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <dx-tabs
                                    width="100%"
                                    class="cc-tabs"
                                    [dataSource]="tabItems"
                                    [(selectedIndex)]="tabIndex"
                                    (onSelectionChanged)="onTabChanged($event)"
                                ></dx-tabs>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <dx-toolbar width="100%" [visible]="announcementAccess?.hasAccess">
                                    <dxi-item
                                        location="after"
                                        widget="dxButton"
                                        [options]="{
                                            type: 'default',
                                            template: 'multiIconTemplate',
                                            text: multiIconButtonOptions,
                                            onClick: onAddNewClick
                                        }"
                                    ></dxi-item>
                                    <app-multi-icon-button-template>
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="POST"
                                            apiUrl="api/announcements"
                                        ></app-security-info>
                                    </app-multi-icon-button-template>
                                </dx-toolbar>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate class="announcements-content dx-theme-border-color">
                    <dx-toolbar *ngIf="tabIndex === 2" width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>Expired date between:</div>
                        </dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-date-box [(value)]="expiredFromDate"></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>and</div>
                        </dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-date-box [(value)]="expiredToDate"></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item
                            location="before"
                            widget="dxButton"
                            [options]="{
                                type: 'default',
                                text: 'Refresh',
                                hint: 'Refresh',
                                icon: iconRefresh,
                                onClick: onForceRefresh
                            }"
                        ></dxi-item>
                    </dx-toolbar>
                    <dx-list
                        width="100%"
                        height="100%"
                        noDataText="There are no announcements"
                        [visible]="!loadingVisible"
                        [items]="announcements"
                    >
                        <div
                            *dxTemplate="let info of 'item'"
                            class="announcement-template-container dx-theme-border-color"
                        >
                            <h4 class="announcement-header">Created By: {{ info.createdBy }}</h4>
                            <div class="announcement-title">
                                <div class="audience">
                                    <h4 class="announcement-header">Audience: {{ info.contextName }}</h4>
                                </div>
                                <div class="action-buttons">
                                    <dx-toolbar width="100%">
                                        <dxi-item location="center" [visible]="isUnreadAnnouncement(info)">
                                            <div *dxTemplate>
                                                <dx-button
                                                    class="mark-as-read-button"
                                                    type="success"
                                                    text="Mark as Read"
                                                    hint="Mark as Read"
                                                    [icon]="iconCheck"
                                                    (onClick)="onMarkAsReadClick(info)"
                                                ></dx-button>
                                            </div>
                                        </dxi-item>
                                        <dxi-item location="center" [visible]="info.allowEdit">
                                            <div *dxTemplate>
                                                <dx-button
                                                    class="edit-button"
                                                    type="default"
                                                    text="Edit"
                                                    hint="Edit"
                                                    [icon]="iconEdit"
                                                    (onClick)="onEditClick(info)"
                                                ></dx-button>
                                            </div>
                                        </dxi-item>
                                        <dxi-item location="center" [visible]="info.allowDelete">
                                            <div *dxTemplate>
                                                <dx-button
                                                    class="delete-button"
                                                    type="danger"
                                                    text="Delete"
                                                    hint="Delete"
                                                    [icon]="iconDelete"
                                                    (onClick)="onDeleteClick(info)"
                                                ></dx-button>
                                            </div>
                                        </dxi-item>
                                    </dx-toolbar>
                                </div>
                            </div>
                            <h5 class="announcement-header">{{ info.title }}</h5>
                            <div
                                class="announcement-release-date"
                                [innerHTML]="getFormatedDate(info.releaseDate)"
                            ></div>
                            <div class="announcement-content" [innerHTML]="info.content | ccSafeHtml"></div>
                        </div>
                    </dx-list>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="center-content">
                    <div>
                        <dx-check-box
                            text="Automatically show new announcements on startup"
                            [(value)]="showAnnouncements"
                            (onValueChanged)="saveShowAnnouncements($event)"
                        ></dx-check-box>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-portal-announcement-editor
    *ngIf="showAddNewAnnouncement"
    [visible]="showAddNewAnnouncement"
    [announcementId]="announcementId"
    [isResidentAnnouncement]="isResidentAnnouncement"
    (onClose)="onCloseEditor()"
    (onRefresh)="onRefresh()"
></app-portal-announcement-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#portal-announcement-container' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
